<template>
    <q-toolbar class="bg-red text-white shadow-5">
        <q-btn flat round dense icon="menu">
            <q-menu>
                <q-list style="min-width: 100px">

                    <q-item clickable v-close-popup v-ripple @click="modeClicked">
                        <q-item-section avatar>
                            <q-icon color="red" :name="modeIcon"></q-icon>
                        </q-item-section>

                        <q-item-section>{{modeText}}</q-item-section>
                    </q-item>

                    <q-item clickable v-close-popup v-ripple @click="helpClicked">
                        <q-item-section avatar>
                            <q-icon color="red" name="question_mark"></q-icon>
                        </q-item-section>

                        <q-item-section>Help</q-item-section>
                    </q-item>

                    <q-item clickable v-close-popup v-ripple @click="disclaimerClicked">
                        <q-item-section avatar>
                            <q-icon color="red" name="announcement"></q-icon>
                        </q-item-section>

                        <q-item-section>Disclaimer</q-item-section>
                    </q-item>

                    <q-item clickable v-close-popup v-ripple @click="refreshClicked">
                        <q-item-section avatar>
                            <q-icon color="red" name="refresh"></q-icon>
                        </q-item-section>

                        <q-item-section>Refresh</q-item-section>
                    </q-item>

                    <q-separator />

                    <q-item clickable v-close-popup v-ripple @click="foaClicked">
                        <q-item-section avatar>
                            <q-icon color="red" name="flag"></q-icon>
                        </q-item-section>

                        <q-item-section>Focus On America</q-item-section>
                    </q-item>

                    <q-item clickable v-close-popup v-ripple @click="ballotClicked">
                        <q-item-section avatar>
                            <q-icon color="red" name="how_to_vote"></q-icon>
                        </q-item-section>

                        <q-item-section>Ballotpedia</q-item-section>
                    </q-item>

                    <q-item clickable v-close-popup v-ripple @click="votingCenterClicked">
                        <q-item-section avatar>
                            <q-icon color="red" name="business"></q-icon>
                        </q-item-section>

                        <q-item-section>Find your Voting Center</q-item-section>
                    </q-item>

                    <q-separator />


                    <q-item clickable v-close-popup v-ripple @click="infoClicked">
                        <q-item-section avatar>
                            <q-icon color="red" name="info"></q-icon>
                        </q-item-section>

                        <q-item-section>Info</q-item-section>
                    </q-item>


                </q-list>
            </q-menu>
        </q-btn>

        <q-toolbar-title>
            Candidate Info Tool
        </q-toolbar-title>

        <div class="text-caption">{{global.version}}</div>


    </q-toolbar>

    <q-dialog v-model="dialogHelp">
        <q-card>
            <q-card-section class="row items-center q-pb-none">
                <div class="text-h6">Search types</div>
                <q-space />
                <q-btn icon="close" flat round dense v-close-popup />
            </q-card-section>

            <q-card-section class="text-grey">
                Examples
                <ul>
                    <li>Candidate: First name, Last name</li>
                    <!-- <li>Party: Democrat, Republican</li> -->
                    <li>Office: House of Rep, Senate</li>
                    <!-- <li>District: 1, 2, 18...</li> -->
                    <li>Donor: FARM, PAC</li>
                </ul>



            </q-card-section>
        </q-card>
    </q-dialog>

    <q-dialog v-model="dialogDisclaimer" persistent>
        <q-card>
            <q-card-section class="row items-center q-pb-none">
                <div class="text-h6">Disclaimer</div>
                <q-space />
                <q-icon name="announcement" color="red" size="2rem" />
            </q-card-section>

            <q-card-section>
                FOA does not endorse any individual candidate.
                <br />
                <br />
                Information displayed in searches are a work in progress. Data will be updated periodically.
                <br />
                <br />
                Information displayed is as accurate as possible and reflects publicly available open source data and
                candidate
                provided positions.
            </q-card-section>

            <q-card-actions align="right">
                <q-btn label="I Understand" color="primary" v-close-popup />
            </q-card-actions>
        </q-card>
    </q-dialog>

    <q-dialog v-model="dialogSplash">
        <q-card style="width:75%;max-width:300px;">

            <q-img src="../assets/img/Splash.jpg" spinner-color="white" />

            <q-card-actions align="right">
                <q-btn flat label="OK" color="primary" v-close-popup />
            </q-card-actions>

        </q-card>
    </q-dialog>

</template>


<style>
</style>

<script>
    import { global } from './Global.js';
    import { useQuasar } from 'quasar';

    export default {
        name: 'HelloWorld',
        mixins: [global],
        data() {
            return {
                global,

                modeIcon: "",
                modeText: "",

                dialogHelp: false,
                dialogDisclaimer: false,
                dialogSplash: false,

                $q: null
            }
        },
        mounted() {

            this.$q = useQuasar();

            this.modeGetFromStorage();
            this.modeGetValues();

            this.$q.dark.set(global.mode == "dark");

            this.checkFirstRun();
        },
        methods: {
            infoClicked() {
                this.dialogSplash = true;
            },
            helpClicked() {
                this.dialogHelp = true;
            },
            refreshClicked() {
                window.location.reload();
            },
            disclaimerClicked() {
                this.dialogDisclaimer = true;
            },
            foaClicked() {
                window.open("https://focusonamerica.us/", "_blank");
            },
            ballotClicked() {
                window.open("https://ballotpedia.org/Alabama_Sample_Ballot", "_blank");

            },
            votingCenterClicked() {
                window.open("https://myinfo.alabamavotes.gov/voterview/");
            },
            checkFirstRun() {
                const firstRun = localStorage.getItem("firstRunCheck");

                if (firstRun != "ran") {

                    localStorage.setItem("firstRunCheck", "ran");
                    // this.dialogDisclaimer = true;
                    this.dialogSplash = true;
                }
            },
            modeGetFromStorage() {
                global.mode = localStorage.getItem("mode");

                if (global.mode == undefined) {
                    global.mode = "light";
                    localStorage.setItem("mode", global.mode);
                }
            },
            modeGetValues() {
                if (global.mode == "light") {
                    this.modeIcon = "dark_mode";
                    this.modeText = "Dark Mode";
                } else {
                    this.modeIcon = "light_mode";
                    this.modeText = "Light Mode";

                }
            },
            modeToggle() {

                if (global.mode == "light") {
                    global.mode = "dark";

                    this.$q.dark.set(true);
                }
                else {
                    global.mode = "light";

                    this.$q.dark.set(false);
                }

                localStorage.setItem("mode", global.mode);
            },
            modeClicked() {

                this.modeToggle();

                this.modeGetValues();
            }
        }
    }
</script>